// Libs
import { AiFillShop } from "react-icons/ai";
import { PiBuildingOfficeFill } from "react-icons/pi";
import { FaCreditCard } from "react-icons/fa6";
import { FaTools } from "react-icons/fa";
import { GiReceiveMoney } from "react-icons/gi";
// import { IoChatbubblesSharp } from "react-icons/io5";
// Types
import { SidebarListType } from "../../Libs/Types/Sidebar";
import { useEffect, useState } from "react";
// Component
import SidebarItem from "./SidebarItem";
import { useLocation, useNavigate } from "react-router-dom";

export default function Sidebar() {
  const navigate = useNavigate();
  const pathName = useLocation();
  const [selectedItem, setSelectedItem] = useState<string>("");

  // Handle Sidebar Item Selection And Navigation
  const handleSidebarItemSelection = (item: string): void => {
    setSelectedItem(item);
    switch (item) {
      case "Dashboard":
        navigate("/dashboard");
        break;
      case "Preauthorization":
        navigate("/preAuthorization");
        break;
      case "Status check":
        navigate("/statusCheck");
        break;
      case "Update claim details":
        navigate("/updateClaim");
        break;
      case "Payers":
        navigate("/payers");
        break;
      case "Ask Caregence":
        navigate("/askCaregence");
        break;
      default:
        break;
    }
  };

  // Manages Item Selection State
  const initItemSelection = () => {
    switch (pathName.pathname) {
      case "/dashboard":
        setSelectedItem("Dashboard");
        break;
      case "/preAuthorization":
        setSelectedItem("Preauthorization");
        break;
      case "/statusCheck":
        setSelectedItem("Status check");
        break;
      case "/updateClaim":
        setSelectedItem("Update claim details");
        break;
      case "/payers":
        setSelectedItem("Payers");
        break;
      default:
        setSelectedItem("");
        break;
    }
  };

  const sideBarList: SidebarListType[] = [
    {
      icon: <AiFillShop size={20} />,
      itemName: "Dashboard",
    },
    {
      icon: <PiBuildingOfficeFill size={20} />,
      itemName: "Preauthorization",
    },
    {
      icon: <FaCreditCard size={20} />,
      itemName: "Status check",
    },
    {
      icon: <FaTools size={20} />,
      itemName: "Update claim details",
    },
    {
      icon: <GiReceiveMoney size={20} />,
      itemName: "Payers",
    },
    // {
    //   icon: <IoChatbubblesSharp size={20} />,
    //   itemName: "Ask Caregence",
    // },
  ];

  useEffect(() => {
    initItemSelection();
    // eslint-disable-next-line
  }, [pathName]);

  return (
    <>
      <div className="flex flex-col items-center md:grid md:grid-rows-1 gap-3 my-2">
        {sideBarList.map((listValue, key) => {
          return (
            <div key={key}>
              <SidebarItem
                itemName={listValue["itemName"]}
                icon={listValue["icon"]}
                selectedItem={selectedItem}
                handleSidebarItemSelection={handleSidebarItemSelection}
              />
            </div>
          );
        })}
      </div>
    </>
  );
}
